import { useEffect, useState } from "react"
import { useToastContext } from "../../../../common/components/ui/toast/toast.context"
import { IPartner, emptyPartners } from "../../../../types/partners.type"
import { createPartners, getPartnersById, updatePartners } from "../../../../common/services/partners.api"
import { Modal } from "flowbite-react"
import Loading from "../../../../common/components/ui/loading/Loading"
import FormEditPartnersData from "../form/FormEditPartnersData"

type Props = {
  partnersId: null | string
  onClose: () => void
}

export default function ModalEditPartners(props: Props) {
  const [partnersId, setPartnersId] = useState<string | null>(null)
  const { showToast } = useToastContext()
  const [partnersData, setPartnersData] = useState<IPartner | null>(null)
  const [formRequestErrors] = useState([])

  const notifySuccess = (text) => showToast({ text, type: 'success' })
  const notifyError = (text) => showToast({ text, type: 'error' })

  const handleCloseModal = () => { props.onClose() }

  useEffect(() => { props.partnersId !== partnersId && setPartnersId(props.partnersId) }, [props.partnersId, partnersId])

  useEffect(() => {
    if (!partnersId) {
      setPartnersData(emptyPartners);
      return;
    }

    async function loadPartnersData() {
      if (!partnersId) return;
      const { data, ok } = await getPartnersById(partnersId);
      if (ok) {
        setPartnersData(data as IPartner);
      }
    }

    loadPartnersData();
  }, [partnersId]);

  async function savePartners(dataToSave: IPartner) {
    try {
      const response = partnersId
        ? await updatePartners(partnersId as string, dataToSave)
        : await createPartners(dataToSave);

      const { ok, data, errors } = response;

      if (ok && data) {
        setPartnersData(data as IPartner);
        if (dataToSave.partnersType == "partner_out") {
          setPartnersId(null)
          setPartnersData(null)
        }
        notifySuccess(`Cliente "${(data as IPartner).companyName}" ${partnersId ? 'atualizado' : 'criado'}!`);
        return { ok, data: data as IPartner, errors: (errors as [{ message: string, path: string[] }]) };
      }

      if (!ok) {
        notifyError(response.message as string);
      }

      return { ok, data: data as IPartner, errors: errors as [{ message: string, path: string[] }] };
    } catch (err) {
      console.log(err);
      notifyError('Erro ao tentar salvar cliente, tente novamente');
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }],
      };
    }
  }

  return (
    <Modal
      size={'5xl'}
      className='relative'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='text-black'>
        <div className="flex items-center justify-start gap-3 text-black">
          <span>
            {`${partnersId ? 'Editando' : 'Criando'}: ${(partnersData || {})?.companyName}`}
          </span>
        </div>
      </Modal.Header>
      <Modal.Body className='w-full relative border-gray flex flex-col text-black' style={{ minHeight: 'calc(50vh - 300px)', height: 'calc(100vh - 300px)' }}>
        {partnersData ? (
          <FormEditPartnersData data={partnersData} onSubmit={savePartners} formRequestErrors={formRequestErrors} />
        ) : <Loading />}
      </Modal.Body>
    </Modal>
  );
}
